module.exports = __webpack_public_path__ + "fonts/avenir_book.995b34ab.ttf";